import {KeyListResponse} from "@/types/service-response";

export default class KeyList {
  private constructor (
    readonly id: number,
    readonly key: string,
    readonly value: string

  ) {}


  static createFromResponse (responseData: KeyListResponse): KeyList {
    return new KeyList(
        responseData.id,
        responseData.key,
        responseData.value
    )
  }

  static createFromResponseList (responseData: KeyListResponse[]): KeyList[]{
    return  responseData.map((item: KeyListResponse)=>{
      return new KeyList(
          item.id,
          item.key,
          item.value,

      )
        }
    )
  }


}